import axios from 'axios'
export const API_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://bazach.com/api'
    : 'https://bazach.com/api'

// export const API_URL = 'http://localhost:3000/api'
export const TOKEN_KEY = 'token'
axios.defaults.withCredentials = true
export const loginTimeStandard = 1000 * 60 * 60 * 24 * 7 // 7 days
export const loginTimeExtended = 1000 * 60 * 60 * 24 * 15 // 15 days

export const doApiGet = async (_url) => {
  try {
    let resp = await axios({
      url: _url,
      method: 'GET',
      headers: {
        'x-api-key': localStorage.getItem(TOKEN_KEY),
      },
    })
    return resp.data
  } catch (err) {
    throw err
  }
}
export const doApiMethod = async (
  _url,
  _method,
  _body = {},
  _content_type = 'application/json',
) => {
  try {
    let resp = await axios({
      url: _url,
      method: _method,
      data: _body,
      headers: {
        'x-api-key': localStorage.getItem(TOKEN_KEY),
        'content-type': _content_type,
      },
    })
    return resp.data
  } catch (err) {
    throw err
  }
}

export const uploadGedcom = async (data) => {
  const formData = new FormData()
  formData.append('gedcom', data.file[0])
  console.log('formData', data.file[0], data)
  return await doApiMethod(
    `${API_URL}/gedcom`,
    'POST',
    formData,
    'multipart/form-data',
  )
}

export const downloadGedcom = async (fileName) => {
  try {
    const response = await axios({
      url: `${API_URL}/gedcom/${fileName}`,
      method: 'GET',
      headers: {
        'x-api-key': localStorage.getItem(TOKEN_KEY),
      },
      responseType: 'blob',
    })

    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    window.URL.revokeObjectURL(url)

    return response.data
  } catch (err) {
    throw err
  }
}
